import { Box, Typography } from '@mui/material';
import { useEditClientDashboardsMutation } from '@api/clientUsers';
import { titles } from '@utils/translations/en';
import { CLIENTS_SUBMODULE_TYPES } from '@constants/constants';
import FormPageLayout from './FormPageLayout';
import AppAccess from './AppAccess';
import DashboardSelector from './DashboardSelector';
import { ClientTableRow } from '../hooks/useClientsTable';
import { setToastMessage } from '@stores/App/slice';
import { TOAST_TYPES } from '@constants/constants';
import { useDispatch } from 'react-redux';
import useGetCompanyAccess from '@hooks/api/useGetCompanyAccess';

const EditCompany = ({
  company,
  onBack,
}: {
  company: ClientTableRow | null;
  onBack: () => void;
}) => {
  const dispatch = useDispatch();
  const [editClientDashboards] = useEditClientDashboardsMutation();

  const companyName = company?.company || '';
  const { companyGames, companySubmodules, setCompanySubmodules } = useGetCompanyAccess({
    clientCode: company?.clientCode ?? '',
  });

  const handleSave = async () => {
    if (!company?.clientCode) return;
    try {
      await editClientDashboards({
        clientCode: company.clientCode,
        payload: { submoduleIds: companySubmodules.map((s) => s.submoduleId) },
      }).unwrap();

      dispatch(
        setToastMessage({
          type: TOAST_TYPES.SUCCESS,
          message: 'Client dashboards updated successfully',
        }),
      );
    } catch (error) {
      dispatch(
        setToastMessage({
          type: TOAST_TYPES.ERROR,
          message: 'Error editing client dashboards',
        }),
      );
    }
  };

  if (!company) {
    return null;
  }

  return (
    <>
      <FormPageLayout
        title={
          <>
            <Typography
              fontSize="22px"
              fontWeight="600"
              lineHeight="1.5rem"
              fontFamily="Manrope, sans-serif"
              sx={{ color: '#6C6C6C' }}
            >{`${titles.EDIT_COMPANY}${companyName ? `:` : ''}`}</Typography>
            {companyName && (
              <Typography
                fontSize="22px"
                fontWeight="600"
                lineHeight="1.5rem"
                fontFamily="Manrope, sans-serif"
                sx={{ color: '#1B1C17' }}
              >{`${companyName}`}</Typography>
            )}
          </>
        }
        onBack={onBack}
        onSave={handleSave}
        onCancel={onBack}
      >
        {companyGames.length > 0 && (
          <Box
            sx={{
              mt: '1rem',
              display: 'flex',
              gap: '2rem',
              alignItems: 'center',
              pb: '2rem',
              borderBottom: '1px solid #E8EAEB',
            }}
          >
            <AppAccess games={companyGames} companyName={companyName} />
          </Box>
        )}

        <Box sx={{ mt: '1rem' }}>
          <Typography fontWeight={700} sx={{ mb: '1rem' }}>
            {titles.SELECT_DASHBOARDS}
          </Typography>
          <DashboardSelector
            selectedSubmodules={companySubmodules}
            onSelectedSubmodulesChange={setCompanySubmodules}
            showAppAccess={false}
            allowedSubmoduleTypes={CLIENTS_SUBMODULE_TYPES}
          />
        </Box>
      </FormPageLayout>
    </>
  );
};

export default EditCompany;
